import {Inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {WINDOW} from '@ng-web-apis/common';
import {decodeToken, getToken, isTokenExpired, setToken} from '@tisa-group/cdk/jwt';
import {TISA_PRODUCTS_URLS} from '@tisa-group/core/providers';
import {ProductsUrls} from '@tisa-group/cdk/models';

@Injectable()
export class AuthGuard {
  constructor(
    @Inject(WINDOW) readonly window: Window,
    @Inject(TISA_PRODUCTS_URLS) readonly productsUrls: ProductsUrls,
  ) {}

  verifyToken(route: ActivatedRouteSnapshot): boolean {
    if (route?.queryParams?.token) {
      setToken(route.queryParams.token);
    }

    const token = getToken();

    if (!token || isTokenExpired(token)) {
      this.window.location.replace(
        `${this.productsUrls.gateway}?redirectUrl=${this.window.location.href}` || '',
      );

      return false;
    }

    return true;
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    return this.verifyToken(route);
  }
}
